<template>
    <div class="row my-3 mx-0">
        <div class="col-4 col-sm-2 mt-2">
            <a :href="index_url">
                <button type="button" class="btn btn-default">
                    {{ $lang('Wróć') }}
                </button>
            </a>
        </div>
        <div class="col-8 col-sm-10 mt-2">
            <div class="pull-right">
                <a v-if="!isTaskNull(previous_task)" :href="previous_url" class="mx-1">
                    <button type="button" class="btn btn-default">
                        <span class="d-none d-md-inline-block">{{ $lang('Poprzednie zgłoszenie') }}</span>
                        <span :title="$lang('Poprzednie zgłoszenie')" class="d-inline-block d-md-none"><i class="fa fa-arrow-circle-left" aria-hidden="true"></i></span>
                    </button>
                </a>
                <a v-if="!isTaskNull(next_task)" :href="next_url" class="mx-1">
                    <button type="button" class="btn btn-default ">
                        <span class="d-none d-md-inline-block">{{ $lang('Następne zgłoszenie') }}</span>
                        <span :title="$lang('Następne zgłoszenie')" class="d-inline-block d-md-none"><i class="fa fa-arrow-circle-right" aria-hidden="true"></i></span>
                    </button>
                </a>
                <button v-if="show_edit_button" type="button" class="btn btn-primary mx-1" data-toggle="modal"
                        data-target="#editTaskModal" :disabled="!jira_connection">
                    <span class="d-none d-md-inline-block">{{ $lang('Edytuj') }}</span>
                    <span :title="$lang('Edytuj')" class="d-inline-block d-md-none"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                </button>
                <button type="button" class="btn btn-primary mx-1" v-if="export_pdf" @click.prevent="runPrint">
                    <span class="d-none d-md-inline-block">{{ $lang('Eksport PDF') }}</span>
                    <span :title="$lang('Eksport PDF')" class="d-inline-block d-md-none"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></span>
                </button>
            </div>
            <div class="col-12 justify-content-end mt-1" v-if="show_edit_button && !jira_connection">
                <span class="text-warning" v-if="client_mode">
                        {{ $lang('System Helpdesk chwilowo niedostępny. Edycja zgłoszenia jest niemożliwa. Spróbuj ponownie za chwilę.') }}
                    </span>
                    <span class="text-warning" v-else>
                        {{ $lang('Wystąpił problem z połączeniem z Jira lub nie został przydzielony klucz Jira. Edycja zgłoszenia niemożliwa.') }}
                    </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'task-show-navigation',
    props: {
        next_task: Number,
        previous_task: Number,
        show_route: String,
        index_route: String,
        query: String,
        searching_no: String,
        client_mode: {type: Boolean, required: true},
        show_edit_button: {type: Boolean, required: false, default: false},
        jira_connection: {type: Boolean, required: false, default: false},
        export_pdf: {type: Boolean, required: false, default: false}
    },
    data() {
        return {
            previous_url: this.show_route + '/' + this.previous_task + (this.searching_no == null ? '' : '?search=' + this.searching_no),
            next_url: this.show_route + '/' + this.next_task + (this.searching_no == null ? '' : '?search=' + this.searching_no),
            index_url: this.index_route + (this.query == null ? '' : '?' + this.query),
        }
    },
    methods: {
        isTaskNull(id) {
            return id === null;
        },
        runPrint() {
            window.print();
        }
    }
}
</script>
